const logos = {
  1: 'etrade',
  21556: 'fidelity',
  3: 'td',
  4: 'capone',
  5: 'scottrade',
  6: 'schwab', // haha, sounds funny
  12: 'chase',
  22: 'merrill',
  34: 'bofa',
  1350: 'amex'
  // 23: 'fidelitynetbenefits'
}

export function getLogo (id) {
  const name = logos[id]
  if (!name) {
    return null
  }

  return require(`assets/bank-logos/${name}.png`)
}



// WEBPACK FOOTER //
// ./src/client/misc/brokerLogos.js